import { Component, Vue, Ref } from "vue-property-decorator";
import LeftTree from '../components/LeftTree.vue'
import TimeAnalysisBody from './components/TimeAnalysisBody'
import './components/timeanalysis.less'
import { StatisticsServiceProxy,TimeAnalysisDTO } from '@/service-proxies/app-v2/mdc.service-proxies'
import { AndonStatisticsServiceProxy  } from '@/service-proxies/app-v2/andon.service-proxies'
import dayjs from 'dayjs'
const stsp = new StatisticsServiceProxy()
const andonStatisticsServiceProxy = new AndonStatisticsServiceProxy();
enum map {
  SHIFT = 1,
  DAY,
  WEEK,
  MONTH
}

@Component({
  components: {
    LeftTree,
    TimeAnalysisBody
  }
})
export default class TimeAnalysis extends Vue {
  @Ref() timeAnalysisBody: TimeAnalysisBody
  operationData = []
  tabsdData = []
  columns = []
  loading = false
  searchValue:any = {}
  secondsToHour(seconds){
    if(seconds){
      return (seconds/3600).toFixed(1);
    }
  }
  getTableList(value) {
    this.loading = true;
    this.operationData = [];
    // let workStationIds = []
    /* if(!value.workStationList || !value.workStationList.length){
      return this.$message.warning('请选择工位')
    }
    if(value.workStationList.length){
      workStationIds = value.workStationList.map(item => item.key);
    } */
    if(!value.workStationList || !value.workStationList.length){
      return this.$message.warning('请选择工位')
    }
    const data = {
      startDate:value.startDate,
      endDate:value.endDate,
      date: value.date,
      shiftIndex: value.shiftIndex,
      statisticalMethod: value.statisticalMethod,
      workStationIds: value.workStationIds
    }
    let chartData = [];
    andonStatisticsServiceProxy.getFrequencyReport(data as any).then(res => {
      this.operationData = res;   //所有的数据
      this.loading = false;
      res.forEach(item => {
        let findIndex = chartData.findIndex(listItem => {
          return listItem.workStationId == (item as any).workStationId;    // && listItem.andonTypeId == item.andonTypeId
        });
        if(findIndex == -1){
          let itemObj = {...item};
          (itemObj as any).totalNumber = (item as any).number || 0;
          (itemObj as any).totalSpendTime = (item as any).fixSpendTime || 0;
          let obj = {
            workStationId:(item as any).workStationId,
            workStationName:item.workStationName,
            list:[itemObj]
          }
          chartData.push(obj)
        }else{
          let findTypeIndex = chartData[findIndex].list.findIndex(v => {
            return v.andonTypeId == item.andonTypeId;
          })
          if(findTypeIndex == -1){
            let o = {
              ...item,
              totalNumber:(item as any).number || 0,
              totalSpendTime:(item as any).fixSpendTime || 0
            }
            chartData[findIndex].list.push(o)
          }else{
            chartData[findIndex].list[findTypeIndex].totalNumber+=(item as any).number;
            let fixSpendTime = (item as any).fixSpendTime || 0;
            chartData[findIndex].list[findTypeIndex].totalSpendTime += fixSpendTime;
          }
        }
      })

      chartData.forEach(item => {
        item.list.forEach(v => {
          v.totalSpendTime = +this.secondsToHour(v.totalSpendTime);
        })
      })
  
      this.chartData = chartData;
    })

    // stsp.timeAnalysisByWcs(data as any).then(res =>{
    //   let arr = [];  

    //   for(var i=0; i<data.workStationList.length; i++) {
    //     for(var j=0; j<res.items.length; j++) {
    //       if(data.workStationList[i].key == res.items[j].workStationId) {
    //         arr.push(res.items[j])
    //       }
    //     }
    //   }   

    //   this.columns = res.head
    //   // this.operationData = res.items
    //   this.operationData = arr
    //   this.loading = false
    // })

  }

  search(value) {
    delete(value.productivityType)
    if(value.workStationList.length){
      let workStationIds = value.workStationList.map(item => item.key);
      value.workStationIds = workStationIds;
    }else{
      value.workStationIds = [];
    }
    this.searchValue = {...value}
    stsp.splitFilter(value).then(res =>{
      this.tabsdData = (res.items).reverse()
      this.timeAnalysisBody.defaultActiveKey = 0
      if(res.items){
        let dateParams = this.getDateParams(this.tabsdData[0].statisticalMethod,this.tabsdData[0].date);
        let params = {
          // startDate:dayjs(value.startDate).format('YYYY-MM-DD 00:00:00'),
          // endDate:dayjs(value.endDate).format('YYYY-MM-DD 23:59:59'),
          workStationIds:value.workStationIds,
          ...this.tabsdData[0],
          ...dateParams
        }
        this.getTableList(params)
      }
    })
  }
  getDateParams(type,startTime){
    let startDate = '';
    let endDate = '';
    if(type == 'SHIFT' || type == 'DAY'){   // 班次
      startDate = dayjs(startTime).format('YYYY-MM-DD 00:00:00');
      endDate = dayjs(startTime).format('YYYY-MM-DD 23:59:59')
    }else if(type == 'WEEK'){
      startDate = dayjs(startTime).format('YYYY-MM-DD 00:00:00');
      endDate = dayjs(startTime).add(6,'day').format('YYYY-MM-DD 23:59:59')
    }else if(type == 'MONTH'){
      startDate = dayjs(startTime).format('YYYY-MM-DD 00:00:00');
      endDate = dayjs(startTime).endOf('month').format('YYYY-MM-DD 23:59:59')
    }
    return {
      startDate,
      endDate
    }
  }
  handleChange(index){
    let itemParams = this.tabsdData[index];
    let dateParams = this.getDateParams(itemParams.statisticalMethod,itemParams.date);
    let params = {
      workStationIds:this.searchValue.workStationIds,
      ...itemParams,
      ...dateParams
    }
    this.getTableList(params);
  }

  outPut() {

  }

  changeX(){

  }

  leftTree() {
    return (
      <left-tree init={['statistical','shift','time','Tree.vue']} onSearch={value => this.search(value)} onOutPut={() => this.outPut()} queryKey="time-analysis"></left-tree>
    )
  }
  chartData = []
  timeAnalysis() {
    return (
      this.operationData ? <time-analysis-body ref="timeAnalysisBody" searchValue={this.searchValue} loading={this.loading} tabsdData={this.tabsdData} data={this.operationData} chartData={this.chartData} columns={this.columns} onChangeTabs={value => this.handleChange(value)}></time-analysis-body> : null
    )
  }

  render() {
    return (
      <a-layout class="timeanalysis-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          {this.timeAnalysis()}
        </a-layout-content>
      </a-layout>
    )
  }
}
